import { render } from "./contractPart.vue?vue&type=template&id=a2055df2&scoped=true"
import script from "./contractPart.vue?vue&type=script&lang=js"
export * from "./contractPart.vue?vue&type=script&lang=js"

import "./contractPart.vue?vue&type=style&index=0&id=a2055df2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2055df2"],['__file',"src/components/createProject/contractPart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a2055df2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2055df2', __exports__)) {
    api.reload('a2055df2', __exports__)
  }
  
  module.hot.accept("./contractPart.vue?vue&type=template&id=a2055df2&scoped=true", () => {
    api.rerender('a2055df2', render)
  })

}


export default __exports__